const data=[
    {
        id:1,
        title: 'Website Development',
        text: 'Lorem ipsum dolor sit, amet consectetur adipisicing elit. Consequatur itaque',
        url: 'http://google.com',
        img: '/undraw_web_development_0l6v.svg',
        fadeBehaviour:'fade-left'
    },
    {
        id:2,
        title: 'Mobile App Development',
        text: 'Lorem ipsum dolor sit, amet consectetur adipisicing elit. Consequatur itaque',
        url: 'http://google.com',
        img: '/undraw_web_developer_re_h7ie.svg',
        fadeBehaviour:'fade-up'
    },
    {
        id:3,
        title: 'Web App Development',
        text: 'Lorem ipsum dolor sit, amet consectetur adipisicing elit. Consequatur itaque',
        url: 'http://google.com',
        img: '/undraw_mobile_web_-2-g8b.svg',
        fadeBehaviour: 'fade-right'
    },
    // {
    //     id:4,
    //     title: 'Desktop App Development',
    //     text: 'Lorem ipsum dolor sit, amet consectetur adipisicing elit. Consequatur itaque',
    //     url: 'http://google.com',
    //     img: '/undraw_mobile_web_-2-g8b.svg',
    //     fadeBehaviour: 'fade-right'
    // }
]
export default data